var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CModal',{staticClass:"max-w-400",on:{"close":_vm.modalClosed},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('iframe',{staticClass:"iframe square",attrs:{"src":_vm.formattedSrc,"frameborder":"0","allow":_vm.videoOptions,"allowfullscreen":""}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }